import styled from 'styled-components';
import bgModal from '../../../assets/images/bg_modal_conlicitaseg.png';

export const Container = styled.div`
  font-family: 'Roboto', sans-serif;
  position: relative;
  background-image: url(${bgModal});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 60px 40px;
  text-align: center;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.15) 1px, transparent 1px);
    background-size: 20px 20px;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    background: transparent;
    border: none;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    z-index: 2;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }

    .material-icons {
      font-size: 20px;
    }
  }

  .modal-content-wrapper {
    position: relative;
    z-index: 1;
    max-width: 600px;
    margin: 0 auto;
  }

  .title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 24px;
  }

  .subtitle {
    font-size: 1.1rem;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 20px;
    line-height: 1.5;
  }

  .description {
    font-size: 1rem;
    color: #333;
    margin-bottom: 32px;
    line-height: 1.6;
  }

  .btn-start {
    background-color: #007bff;
    border: none;
    padding: 14px 32px;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 4px;
    margin-bottom: 16px;
    transition: background-color 0.2s;

    &:hover {
      background-color: #0056b3;
    }

    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  }

  .btn-remind {
    color: #333;
    font-size: 0.95rem;
    font-weight: 500;
    text-decoration: none;
    display: block;
    padding: 8px 0;

    &:hover {
      color: #1a1a1a;
      text-decoration: underline;
    }

    &:focus {
      outline: none;
      text-decoration: underline;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 24px;

    .title {
      font-size: 2rem;
    }

    .subtitle {
      font-size: 1rem;
    }

    .description {
      font-size: 0.95rem;
    }

    .btn-start {
      width: 100%;
    }
  }
`;
